c-form-dropdown {
    .dropdown {
        margin-left: 20px;
        .form-dropdown {
            padding-top: 10px;
            select {
                width: 95%;
                height: 2.5rem;
                border-radius: 10px;
                border: 2px solid black;
                text-align: center;
                font-size: var(--font-size);
            }
        }
        margin-bottom: 10px;
    }
}
